// extracted by mini-css-extract-plugin
export default {"wrap":"ys5JlY","tab":"kOu3P8","isActive":"P_JgXS","title":"l2a4EU","subtitle":"dbkoG_","picture":"MBQQ0f","isShow":"YTNv_F"};